{
  "home": {
    "tagline": "Több mint 1 millió kutyatulajdonos edz a Hundeo-val",
    "subline": "Valódi kutyakiképzők ajánlásával",
    "appStorePrefix": "Töltsd le innen:",
    "playStorePrefix": "Letöltés innen:",
    "qrHint": "Nyisd meg az alkalmazást a telefonodon",
    "qrCaption": "Olvasd be a kódot a kamerával",
    "socialProof": "5 000+ ötcsillagos értékelés",
    "imprint": "Impresszum",
    "privacy": "Adatvédelem",
    "language": "Nyelv",
    "openWebsite": "Tovább a webhelyre",
    "openInApp": "Megnyitás a Hundeo appban",
    "openInAppHint": "Átirányítunk az appodba",
    "openInAppButton": "Megnyitás",
    "promoRedirectTitle": "Megnyitjuk az ajánlatodat …",
    "promoRedirectButton": "Tovább az ajánlathoz"
  }
}
